import { h } from "preact";
export const IconFilters = () => {
  return (
    <svg width="21px" height="14px" viewBox="0 0 21 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"> 
        <g id="Batch-2-Revisions" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="PLP-W--Visual-Subcollections-Copy" transform="translate(-1028.000000, -597.000000)">
                <g id="icon-filters" transform="translate(1029.000000, 597.000000)">
                    <g id="Group">
                        <path d="M6,0.86 C7.18,0.86 8.14,1.82 8.14,3 C8.14,4.18 7.18,5.14 6,5.14 C4.82,5.14 3.86,4.18 3.86,3 C3.86,1.82 4.82,0.86 6,0.86 M6,0 C4.34,0 3,1.34 3,3 C3,4.66 4.34,6 6,6 C7.66,6 9,4.66 9,3 C9,1.34 7.66,0 6,0 L6,0 Z" id="Shape" fill="currentColor" fill-rule="nonzero"></path>
                        <line x1="8.64" y1="3" x2="19" y2="3" id="Path" stroke="currentColor" stroke-width="1.04"></line>
                        <line x1="0" y1="3" x2="3.31" y2="3" id="Path" stroke="currentColor" stroke-width="1.04"></line>
                    </g>
                    <g id="Group" transform="translate(0.000000, 8.000000)">
                        <path d="M13,0.86 C14.18,0.86 15.14,1.82 15.14,3 C15.14,4.18 14.18,5.14 13,5.14 C11.82,5.14 10.86,4.18 10.86,3 C10.86,1.82 11.82,0.86 13,0.86 M13,0 C11.34,0 10,1.34 10,3 C10,4.66 11.34,6 13,6 C14.66,6 16,4.66 16,3 C16,1.34 14.66,0 13,0 L13,0 Z" id="Shape" fill="currentColor" fill-rule="nonzero"></path>
                        <line x1="10.35" y1="3" x2="0" y2="3" id="Path" stroke="currentColor" stroke-width="1.04"></line>
                        <line x1="19" y1="3" x2="15.68" y2="3" id="Path" stroke="currentColor" stroke-width="1.04"></line>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
};
